import { useQuery } from '@apollo/client';
import { generateSingleItemQuery } from '../application/query';
function useGetImageIdFromRelation(id, imageRelation, actions, isUsingRelationImage, isPreview, hasImgSrc) {
  const skip = !id || hasImgSrc || typeof id !== 'string' || !isUsingRelationImage || !Object.keys(actions).length;
  const [imageRelationData = ''] = imageRelation;
  const [relationName = '', relationProp = ''] = imageRelationData.split('.');
  const {
    getPublished,
    get
  } = actions;
  const getAction = isPreview ? get : getPublished || get;
  const props = imageRelationData ? `${relationName} { ${relationProp} }` : 'id';
  const {
    data = {},
    loading,
    error
  } = useQuery(generateSingleItemQuery(getAction, props), {
    variables: {
      id
    },
    skip
  });
  return {
    data,
    loading,
    error
  };
}
export default useGetImageIdFromRelation;
//# sourceMappingURL=use-get-image-id-from-relation.js.map